module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-700.woff2?c18ee39fb002ad58b6dc595476f88fef";